import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFlowService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-need-help',
  templateUrl: './need-help.component.html',
  styleUrls: ['./need-help.component.scss']
})
export class NeedHelpComponent {

  helpForm!: FormGroup;
isSubmitted = false;
  isSubmitting = false;
  apiErrorMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthFlowService
  ) { }

  ngOnInit(): void {
    this.helpForm = this.fb.group({
      mobile: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[6-9]\d{9}$/),
          Validators.minLength(10),
          Validators.maxLength(10)
        ]
      ],
      subject: [
        '',
        [
          Validators.required,
          Validators.maxLength(120)
        ]
      ],
      description: [
        '',
        [
          Validators.required
        ]
      ]
    });

    this.helpForm.valueChanges.subscribe(() => {
      this.apiErrorMessage = null;
    });
  }

  submit(): void {
 console.log('Submit clicked');
    if (this.helpForm.invalid) {
      this.helpForm.markAllAsTouched();
      return;
    }

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.apiErrorMessage = null;

    const payload = {
      mobileNumber: this.helpForm.value.mobile,
      ticketSubject: this.helpForm.value.subject.trim(),
      ticketDescription: this.helpForm.value.description.trim()
    };

    this.authService.submitNeedHelp(payload).subscribe({

      next: (res: any) => {

        this.isSubmitting = false;

        if (!res?.success) {
          this.apiErrorMessage = res?.message || 'Unable to submit request.';
          return;
        }

        // Success
        this.helpForm.reset();
        this.isSubmitted = true;

        // Optional: close the menu/dialog here
        // this.menuTrigger.closeMenu();

        // "Help request submitted successfully"
      },

      error: (err: any) => {

        this.isSubmitting = false;

        this.apiErrorMessage =
          err.error?.message || 'Something went wrong.';
      }

    });
  }

  onlyNumbers(event: any): void {

    event.target.value = event.target.value.replace(/[^0-9]/g, '');

    this.helpForm.get('mobile')?.setValue(
      event.target.value,
      { emitEvent: false }
    );
  }
}
